import { render, staticRenderFns } from "./FullScreenPop.vue?vue&type=template&id=207717e0&scoped=true&"
import script from "./FullScreenPop.vue?vue&type=script&lang=js&"
export * from "./FullScreenPop.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenPop.vue?vue&type=style&index=0&id=207717e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207717e0",
  null
  
)

export default component.exports